import { useState, useMemo, useCallback, useEffect } from 'react';
import { length, trim, gte, pluck, includes, defaultTo } from 'ramda';

const useCreateTeam = (teams, initialTeamName = '') => {
  const [isFocus, setIsFocus] = useState(false);
  const [teamName, setTeamName] = useState(initialTeamName);
  const [touched, setTouched] = useState(false);

  useEffect(() => {
    setTeamName(initialTeamName);
    setTouched(false);
    setIsFocus(false);
  }, [initialTeamName]);

  const reset = useCallback((newTeamName) => {
    setTouched(false);
    setTeamName(defaultTo(initialTeamName, newTeamName));
    setIsFocus(false);
  }, [initialTeamName]);

  const onFocus = useCallback(() => {
    if (!touched) {
      setIsFocus(true);
    }
  }, [touched]);

  const onBlur = useCallback(() => {
    setIsFocus(false);
    setTouched(true);
  }, []);

  const isValidFn = (value) => gte(length(trim(value)), 2);

  const {
    alreadyExists,
    isValid
  } = useMemo(() => {
    const trimName = trim(teamName);
    const teamNames = pluck('name', teams || []);
    return {
      alreadyExists: includes(trimName, teamNames),
      isValid: isValidFn(trimName)
    };
  }, [teams, teamName]);

  return {
    touched,
    isFocus,
    teamName,
    setTeamName,
    alreadyExists,
    isValid,
    onBlur,
    onFocus,
    reset
  };
};

export default useCreateTeam;